import { Component } from '@angular/core';
import BaseDetailPageConfig from '../../../../models/base-detail-page.config';
import { LawsService } from '../../../../services/api/general-settings/laws.service';
import { RouteService } from '../../../../services/route.service';
import { BaseDetailPageComponent } from '../../../../components/pages/base-detail-page/base-detail-page.component';

@Component({
  selector: 'app-laws-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './laws-detail-page.component.html',
  styleUrl: './laws-detail-page.component.scss'
})
export class LawsDetailPageComponent {
 baseDetailPageConfig!: BaseDetailPageConfig;
  readonlyUserDetail:boolean

  law?: any;

  constructor(
    private lawsService: LawsService,
    private routeService: RouteService
  ) {
    this.readonlyUserDetail = true
  }

  ngOnInit(): void {

    this.baseDetailPageConfig = {
      pageTitle: 'Laws',
      cardTitle: 'Law Detail',
      editItemButton: {
        type: 'success',
        title: 'Edit Law',
        onClick: () => {
          this.routeService.lawsUpdate(this.law?.lawId)
        }
      },
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'Jurisdiction',
            label: 'Jurisdiction',
            value: (item: any) => {
              return item.jurisdiction.name;
            }
          },
          {
            attribute: 'Name',
            label: 'Name',
            value: (item: any) => {
              return item.name;
            }
          },
          {
            attribute: 'validityStartDate',
            label: 'Validity start date',
            value: (item: any) => {
              return item.validityStartDate;
            }
          },        
          {
            attribute: 'validityEndDate',
            label: 'Validity end date',
            value: (item: any) => {
              return item.validityEndDate;
            }
          },     
          {
            attribute: 'createTime',
            label: 'Create Time',
            value: (item: any) => {
              return item.createTime;
            }
          },
        ]
      },
      apiDetailService: (lawId: number) => this.lawsService.detail(lawId),
      routeParamName: 'lawId',
      responseModelName: 'law'
    };

  }

  onLoadedDetail(data: any) {
    this.law = data;
  }
}
